export const taxonomyRanks = [
  'superkingdom',
  'kingdom',
  'phylum',
  'class',
  'order',
  'family',
  'genus',
  'species',
];
